export enum DataRoomStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum DataRoomAccessPermission {
  VIEWER = 'viewer',
  VIEWER_DOWNLOAD = 'viewer-download',
}

export enum DataRoomAccessStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  REVOKED = 'revoked',
}

/**
 * What the External Recipients field is allowed to do with a typed address — 20.4.1 section 5.
 *
 * Three of these are refusals, and each refuses for its own reason: a stakeholder belongs on the
 * other tab, a guest without the Data Rooms toggle is granted access in Team Settings rather than
 * here, and a guest with it already reaches every room in the company, so a per-room grant would
 * control nothing.
 */
export enum DataRoomRecipientEligibility {
  ELIGIBLE = 'eligible',
  GUEST_WITH_ROOMS = 'guest-with-rooms',
  GUEST_WITHOUT_ROOMS = 'guest-without-rooms',
  STAKEHOLDER = 'stakeholder',
}

export enum DataRoomRecipientKind {
  EXTERNAL = 'external',
  INTERNAL = 'internal',
}
